<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
            v-model="searchForm.advTitle"
            placeholder="人物名称"
            width="50"
          />
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.state"
                  placeholder="状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.shState"
                  placeholder="审核状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="人物名称"
      >
        <template slot-scope="scope">
          {{scope.row.advTitle}}
        </template>
      </el-table-column>
      <el-table-column
        label="照片"
        :show-overflow-tooltip="true"
        width="150"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.advImg!=''">
            <img :src= "getImgUrl(scope.row)" style="width: 150px;height: 150px; "/>

          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="背景图"
              :show-overflow-tooltip="true"
              width="150"
      >
        <template slot-scope="scope">


          <img :src= "getImgUrl2(scope.row)" style="width: 150px;height: 150px; "/>


        </template>
      </el-table-column>
      <el-table-column
              label="生卒年月日"
              width="200"
      >
        <template slot-scope="scope">
          {{scope.row.startTime}}至{{scope.row.endTime}}
        </template>
      </el-table-column>
      <el-table-column
              label="编号"
      >
        <template slot-scope="scope">
          {{scope.row.advPos}}
        </template>
      </el-table-column>
      <el-table-column
              label="性别"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.media_type=='1'">
            男
          </div>
          <div v-else-if="scope.row.media_type=='2'">
            女
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="馆分类"
        prop="sort_id"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.businessname}}

        </template>
      </el-table-column>
      <el-table-column
              label="排序"
      >
        <template slot-scope="scope">
          {{scope.row.advSort}}
        </template>
      </el-table-column>
      <el-table-column
              label="生平照片是否显示"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.is_photo=='0'">
            显示
          </div>
          <div v-else-if="scope.row.is_photo=='1'">
            不显示
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="祭拜次数"
      >
        <template slot-scope="scope">
          {{scope.row.worship_num}}
        </template>
      </el-table-column>
      <el-table-column
              label="点赞数"
      >
        <template slot-scope="scope">
          {{scope.row.give_num}}
        </template>
      </el-table-column>
      <el-table-column
              label="关注数"
      >
        <template slot-scope="scope">
          {{scope.row.follow_num}}
        </template>
      </el-table-column>
      <el-table-column
              label="创建人"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.username==''">
            平台
          </div>
          <div v-else>
            {{scope.row.username}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="花圈"
      >
        <template slot-scope="scope">
          {{scope.row.wreath}}
        </template>
      </el-table-column>
      <el-table-column
              label="蜡烛"
      >
        <template slot-scope="scope">
          {{scope.row.candle}}
        </template>
      </el-table-column>
      <el-table-column
              label="敬香"
      >
        <template slot-scope="scope">
          {{scope.row.censer}}
        </template>
      </el-table-column>
      <el-table-column
              label="供果"
      >
        <template slot-scope="scope">
          {{scope.row.fruit}}
        </template>
      </el-table-column>

      <el-table-column
              label="是否需要密码查看"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.is_password==''">
            不需要密码
          </div>
          <div v-else>
           需要密码( {{scope.row.is_password}})
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="状态"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='0'">
            正常
          </div>
          <div v-else-if="scope.row.state=='1'">
           禁用
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="审核状态"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.shState=='0'">
            待审核
          </div>
          <div v-else-if="scope.row.shState=='1'">
            审核通过
          </div>
          <div v-else-if="scope.row.shState=='2'">
            审核不通过
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="审核备注"
              prop="sh_remark"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.shRemark}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="220"
      >
        <template slot-scope="scope">
          <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="openEditForm(scope.row)"
          >编辑</el-button>
            <el-button
                    v-if="scope.row.state=='0'"
                    type="primary"
                    plain
                    size="mini"
                    @click="update(scope.row.id,1)"
            >禁用</el-button>
            <el-button
                    v-if="scope.row.state=='1'"
                    type="primary"
                    plain
                    size="mini"
                    @click="update(scope.row.id,0)"
            >恢复</el-button>
          <el-button
                  v-if="scope.row.shState=='0'"
                  type="primary"
                  plain
                  size="mini"
                  @click="openShForm(scope.row)"
          >审核</el-button>
          <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="openPhotoForm(scope.row)"
          >生前照片管理</el-button>

          <el-button
            type="primary"
            plain
            size="mini"
            @click="del(scope.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />
    <sh-form
            :oneclass="oneclass"
            v-model="shFormVisible"
            @submit="getTableData"
    />
    <photo-form
            :oneclass="oneclass"
            v-model="photoFormVisible"
            @submit="getTableData"
    />


  </d2-container>
</template>
<script>
import * as oneclassService from "@/api/sys/oneclass";
import * as agentService from "@/api/sys/agent";
import editForm from "./editForm";
import shForm from "./shForm";
import photoForm from "./photoForm";
import util from '@/libs/util.js'
export default {
  name: "SmallposterPage",
  components: { editForm, shForm,photoForm},
  data() {
    return {
      searchForm: {
          advTitle: ""
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
        typeOptions: [
            {
                value: "0",
                label: "正常"
            },
            {
                value: "1",
                label: "禁用"
            }
        ],
      typeOptions2: [
        {
          value: "0",
          label: "待审核"
        },
        {
          value: "1",
          label: "审核通过"
        },
        {
          value: "2",
          label: "审核不通过"
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
        clicksFormVisible:false,
        exposureFormVisible: false,
      editFormVisible: false,
      shFormVisible: false,
      photoFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
          xt_id: util.cookies.get('xt_id'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getAdvertJzDisposePagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
      getImgUrl(row){
      var url="https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com";
      if(row.advImg!=null && row.advImg!=""){
        url+=row.advImg
        }

          return url;
      },
    getImgUrl2(row){
      var url="https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com";
      if(row.bjImg!=null && row.bjImg!=""){
        url+=row.bjImg
      }

      return url;
    },
    getImgUrl3(row){
      var url="https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com";
      if(row.swImg!=null && row.swImg!=""){
        url+=row.swImg
      }

      return url;
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(oneclass) {
      this.oneclass = oneclass;
      this.editFormVisible = true;
    },
    openShForm(oneclass) {
      this.oneclass = oneclass;
      this.shFormVisible = true;
    },
    openPhotoForm(oneclass) {
      this.oneclass = oneclass;
      this.photoFormVisible = true;
    },
      openExposureForm(oneclass) {
          this.oneclass = oneclass;
          this.exposureFormVisible = true;
      },
      openClicksForm(oneclass) {
          this.oneclass = oneclass;
          this.clicksFormVisible = true;
      },

    add() {
      this.oneclass = {};
      this.editFormVisible = true;
    },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          agentService
          .batchAdvertJzDispose({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData();
          });
      });
    },
      update(id,type){
          let msg = type == 1 ? "禁用" : "恢复";
          this.$confirm("确认"+msg+"操作？", "确认信息", {
              distinguishCancelAndClose: true,
              confirmButtonText: msg,
              cancelButtonText: "取消"
          }).then(() => {
              agentService.updateAdvertJzDispose({id:id,state:type}).then(() => {
                  this.getTableData();
              });
          });
      },
    del(id) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          agentService.delAdvertJzDispose({id:id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
